/* global FB */
;(function() {
  'use strict'

  shareService.$inject = ["glAnalytics", "glUtils", "configService"];
  angular.module('core.share').service('shareService', shareService)

  // --------------------

  /* @ngInject */
  function shareService(glAnalytics, glUtils, configService) {
    return {
      share: share,
      manualShare: manualShare,
    }

    function manualShare(platform, data) {
      if (platform === 'facebook') {
        shareToFacebook({
          caption: data.text,
          link: data.url,
          picture: data.image,
          method: 'feed',
        })
      }
      if (platform === 'twitter') {
        shareToTwitter({
          text: data.text,
          url: data.url,
          image: data.image,
        })
      }
    }

    function share(type, data, platform) {
      var opts = makeOpts(type, data, platform)

      if (platform === 'facebook') {
        shareToFacebook(opts)
      } else if (platform === 'twitter') {
        shareToTwitter(opts)
      }

      glAnalytics.track('Share', 'type-' + type)
      glAnalytics.track('Share', 'to-' + platform)
    }

    function makeOpts(type, data, platform) {
      var opts
      if (platform === 'facebook') {
        if (type === 'activity') {
          opts = facebookActivityOpts(data)
        } else if (type === 'element') {
          opts = facebookElementOpts(data)
        } else if (type === 'post') {
          opts = facebookPostOpts(data)
        }
      } else if (platform === 'twitter') {
        if (type === 'activity') {
          opts = twitterActivityOpts(data)
        } else if (type === 'element') {
          opts = twitterElementOpts(data)
        } else if (type === 'post') {
          opts = twitterPostOpts(data)
        }
      }
      return opts
    }

    /**
     *  Facebook Option Builders
     */
    function facebookActivityOpts(item) {
      // todo: deeplinks + og tags
      var opts = {}
      opts.method = 'feed'
      opts.link =
        configService.getUserPortalUrl() + '/message/' + item.object.id
      opts.name = 'Check out this message on Glow'
      return opts
    }

    /**
     *  Twitter Option Builders
     */
    function twitterActivityOpts(item) {
      // todo: deeplinks + og tags
      var opts = {}
      opts.url = configService.getUserPortalUrl() + '/message/' + item.object.id
      opts.text = 'Check out this message on Glow:'
      return opts
    }

    function facebookElementOpts(element) {
      // TODO: deeplinks + og tags
      var opts = {}
      opts.method = 'feed'
      opts.link = window.location.href
      opts.name = 'Check out "' + element.title + '" on Glow'
      return opts
    }

    function twitterElementOpts(element) {
      // TODO: deeplinks + og tags
      var opts = {}
      opts.url = window.location.href
      opts.text = 'Check out "' + element.title + '" on Glow:'
      return opts
    }

    function facebookPostOpts() {
      // TODO: deeplinks + og tags
      var opts = {}
      opts.method = 'feed'
      opts.link = window.location.href
      opts.name = 'Check out this message on Glow'
      return opts
    }

    function twitterPostOpts() {
      // TODO: deeplinks + og tags
      var opts = {}
      opts.url = window.location.href
      opts.text = 'Check out this message on Glow:'
      return opts
    }

    function shareToFacebook(opts) {
      FB.ui(opts)
    }

    function shareToTwitter(opts) {
      var width = 575
      var height = 300
      var url = 'https://twitter.com/share?'

      addParam('url', opts.url)
      addParam('text', opts.text)
      // var url = 'https://twitter.com/share?url=http://www.glowfeedback.com' +
      //     '&text=We just joined Glow, the feedback app that lets us talk to our customers. ' +
      //     'Join Glow %26 give us feedback!';
      glUtils.popup(url, '_blank', width, height)

      function addParam(key, value) {
        var prefix = url[url.length - 1] === '?' ? '' : '&'
        if (!key || !value) {
          return
        }
        url += prefix + key + '=' + encodeURIComponent(value)
      }
    }

    // function replaceActivitySummaryLink (summary, text) {
    //     var linkRegex = /{(.+?):(.+?)}/g;
    //     return summary.replace(linkRegex, text);
    // }
  }
})()
